// app/javascript/controllers/audio_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "tags", "tagsvalue"]

    connect() {
        this.recording = false
        let tags = this.tagsTarget.dataset.value?.split(',');
        if (!tags) tags = [];
        this.tags = tags.filter(t => !!t);
        this.attachEvent();
        this.updateTags();
    }

    attachEvent() {
        this.inputTarget.addEventListener('keypress', (event) => {
            if (event.key === 'Enter') {
                this.tags.push(this.inputTarget.value);
                console.log(this.tags)
                this.inputTarget.value = '';
                event.preventDefault();
                this.updateTags();
            }
        })
    }

    updateTags() {
        this.tagsTarget.innerHTML = '';
        this.tags.forEach(tag => {
            let span = document.createElement('div');
            span.innerHTML = `<span  class="badge relative badge-accent"> 
                                <span>${tag}</span> 
                                 <button class="text-red-500 text-base font-bold cursor-pointer px-1"
                                 data-tag="${tag}" 
                                 data-action="click->form-tags#removeTag">x</button> 
                                </span>`;
            this.tagsTarget.appendChild(span);
        });
        this.updateValue();
    }

    updateValue() {
        this.tagsvalueTarget.value = this.tags.join(',');
    }

    removeTag(event) {
        event.preventDefault();
        let currentTag = event.target.dataset.tag;
        this.tags = this.tags.filter(t => t !== currentTag);
        this.updateTags();
    }
}